<script>
    import { navigate } from "svelte-routing";
    import Constantes from "../../Classes/Constantes";

    function handleEducadorFisico() {
      // Lógica para redirecionar ou iniciar o processo de cadastro para educadores físicos
    }

    function handleLogin() {
      navigate(Constantes.tela_login2);
    }
</script>

<style>
  .fonte1 {
    font-family: 'Oswald', sans-serif;
  }

  .fundo {
    margin: 0;
    padding: 0;
    background-image: url("/img/pista3.jpg");
    background-size: cover;
    background-position: center;
  }

  .hero {
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 50px 20px;
    border-radius: 10px;
    margin: 20px;
    color: #fff;
    max-width: 800px;
    margin: 20px auto;
  }

  .hero h1 {
    font-size: 2.5rem;
    color: #fff;
  }

  .hero p {
    font-size: 1.2rem;
    color: #ddd;
    margin-bottom: 20px;
  }

  .hero img {
    max-width: 100%;
    height: auto;
    margin: 20px 0;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  }

  /* Limita o tamanho da imagem para imitar uma tela de celular */
  @media (min-width: 768px) {
    .hero img {
      max-width: 375px; /* Largura típica de um iPhone */
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 30px;
  }

  .button-group button {
    padding: 15px 25px;
    font-size: 1rem;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 80%;
    max-width: 300px;
  }

  .button-group button:hover {
    background-color: #0056b3;
  }

  .button-group .login-btn {
    background-color: #28a745;
  }

  .button-group .login-btn:hover {
    background-color: #218838;
  }

  /* Ajuste o layout para dispositivos maiores que 768px */
  @media (min-width: 768px) {
    .hero {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      text-align: left;
    }

    .hero img {
      margin: 0;
      max-width: 100%;
    }

    /* Inverter o layout a cada bloco de conteúdo */
    .hero div:nth-child(odd) {
      grid-column: 1;
    }

    .hero div:nth-child(even) {
      grid-column: 2;
    }
  }
</style>

<div class="fundo fonte1">
  <div class="hero">
    <div>
      <h1>Agilize a Prescrição de Treinos com Apenas Alguns Cliques!</h1>
      <p>
        O nosso aplicativo transforma a maneira como você prescreve treinos. Com uma interface simples e intuitiva, você pode selecionar datas e associar treinos prontos a seus atletas em segundos. 
        Ganhe tempo e eficiência ao aplicar treinos para vários atletas de uma só vez.
      </p>
    </div>

    <img src="./img/print1.png" alt="Print da tela de seleção de datas e treinos" />

    <div>
      <p>
        Visualize seus treinos em um calendário interativo, marque a realização dos treinos e dê feedbacks diretamente no aplicativo. Personalize e adapte facilmente os planos de treino, tudo em uma única plataforma.
      </p>
    </div>

    <img src="./img/print2.png" alt="Print da tela de visualização do plano de treino" />

    <div class="button-group">
      <button on:click={handleEducadorFisico}>Sou educador físico e quero utilizar o aplicativo</button>
      <button on:click={handleLogin} class="login-btn">Já é cadastrado? Efetue o login</button>
    </div>
  </div>
</div>
